import React from 'react';

export const SSOComplete = () => {
  React.useEffect(() => {
    window.opener.postMessage('SSO_COMPLETE', '*');
    window.close();
  }, []);

  return <div>Completing SSO...</div>;
};
